export const DEFAULT_SURVEY_MARKETING_URL = "https://www.feradel.com/products/ferasurvey/";

const SAFE_MARKETING_PARAMETERS = /^(utm_(source|medium|campaign|term|content)|gclid|fbclid)$/i;

export const validMarketingUrl = (value) => {
  try {
    const target = new URL(String(value || ""));
    return target.protocol === "https:" && Boolean(target.hostname);
  } catch {
    return false;
  }
};

export const marketingDestination = (
  configuredUrl,
  search = window.location.search
) => {
  const target = new URL(
    validMarketingUrl(configuredUrl) ? configuredUrl : DEFAULT_SURVEY_MARKETING_URL
  );
  const current = new URLSearchParams(search || "");
  current.forEach((value, key) => {
    if (SAFE_MARKETING_PARAMETERS.test(key) && value.length <= 512) {
      target.searchParams.set(key, value);
    }
  });
  return target.toString();
};

